import { combineReducers } from 'redux';

import entities from '@reducers/entities';
import filter from '@reducers/filter';
import menu from '@reducers/menu';
import paginator from '@reducers/paginator';
import route from '@reducers/routeReducer';
import scroll from '@reducers/scroll';
import security from '@reducers/security';
import streamPlayback from '@reducers/streamPlayback';
import table from '@reducers/table';

const appReducer = combineReducers({
    entities,
    filters: filter,
    menu,
    paginator,
    security,
    scroll,
    table,
    streamPlayback,
    route,
});

export default appReducer;
